import { render, staticRenderFns } from "./VTimelineItem.vue?vue&type=template&id=30a6ab9a&scoped=true&"
import script from "./VTimelineItem.vue?vue&type=script&lang=js&"
export * from "./VTimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./VTimelineItem.vue?vue&type=style&index=0&id=30a6ab9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a6ab9a",
  null
  
)

export default component.exports